import React from "react";
import "./RunnersSection.css";

/* Import Images */
import runnersImg from "../Assets/images/group2.jpeg";
import athletesImg from "../Assets/images/exercise.jpg";
import communitiesImg from "../Assets/images/washhand.jpg";

const runnersData = [
  {
    number: "1000+",
    label: "Runners",
    image: runnersImg,
  },
  {
    number: "10+",
    label: "Celebrity Athletes",
    image: athletesImg,
  },
  {
    number: "10+",
    label: "Communities",
    image: communitiesImg,
  },
];

const RunnersSection = () => {
  return (
    <section className="runners-section">

      {runnersData.map((item, index) => (
        <div className="runner-card" key={index}>

          <img src={item.image} alt={item.label} />

          <div className="runner-overlay"></div>

          <div className="runner-text">
            <h2>{item.number}</h2>
            <p>{item.label}</p>
          </div>

        </div>
      ))}

    </section>
  );
};

export default RunnersSection;